import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alerts container-fluid py-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-info text-center py-5"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsFilters = _resolveComponent("AlertsFilters")!
  const _component_AlertsKPIs = _resolveComponent("AlertsKPIs")!
  const _component_ForexAlertsTable = _resolveComponent("ForexAlertsTable")!
  const _component_SportsAlertsTable = _resolveComponent("SportsAlertsTable")!
  const _component_OrphanedMessages = _resolveComponent("OrphanedMessages")!
  const _component_ManualLinkModal = _resolveComponent("ManualLinkModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading && _ctx.channels.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
          ], -1),
          _createElementVNode("p", { class: "mt-3 text-muted" }, "Cargando canales...", -1)
        ]))]))
      : (_ctx.channels.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-info-circle fa-3x mb-3" }, null, -1),
            _createElementVNode("h5", null, "No hay canales con monitoreo activo", -1),
            _createElementVNode("p", { class: "mb-0" }, " Configure el monitoreo de canales en la sección de administración. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_AlertsFilters, {
              channels: _ctx.channels,
              "selected-channel-id": _ctx.selectedChannelId,
              "selected-month": _ctx.selectedMonth,
              "onUpdate:selectedMonth": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
              "selected-year": _ctx.selectedYear,
              "onUpdate:selectedYear": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYear) = $event)),
              months: _ctx.months,
              years: _ctx.years,
              "is-loading": _ctx.isLoading,
              onSelectChannel: _ctx.selectChannel,
              onRefresh: _ctx.refreshAlerts
            }, null, 8, ["channels", "selected-channel-id", "selected-month", "selected-year", "months", "years", "is-loading", "onSelectChannel", "onRefresh"]),
            _createVNode(_component_AlertsKPIs, {
              kpis: _ctx.kpis,
              alerts: _ctx.groupedAlerts,
              "alert-type": _ctx.currentAlertType
            }, null, 8, ["kpis", "alerts", "alert-type"]),
            (
          _ctx.currentAlertType === 'forex' ||
          _ctx.currentAlertType === 'synthetic_indices'
        )
              ? (_openBlock(), _createBlock(_component_ForexAlertsTable, {
                  key: 0,
                  alerts: _ctx.groupedAlerts,
                  "alert-type": _ctx.currentAlertType,
                  "is-loading": _ctx.isLoading,
                  "expanded-alert-id": _ctx.expandedAlertId,
                  "editing-alert-id": _ctx.editingAlertId,
                  "is-saving": _ctx.isSaving,
                  "is-reprocessing": _ctx.isReprocessing,
                  onToggleExpand: _ctx.toggleExpand,
                  onStartEdit: _ctx.startEditing,
                  onCancelEdit: _ctx.cancelEditing,
                  onSaveEdit: _ctx.saveEditing,
                  onReprocessMessage: _ctx.handleReprocessMessage
                }, null, 8, ["alerts", "alert-type", "is-loading", "expanded-alert-id", "editing-alert-id", "is-saving", "is-reprocessing", "onToggleExpand", "onStartEdit", "onCancelEdit", "onSaveEdit", "onReprocessMessage"]))
              : (_openBlock(), _createBlock(_component_SportsAlertsTable, {
                  key: 1,
                  alerts: _ctx.groupedAlerts,
                  "is-loading": _ctx.isLoading,
                  "expanded-alert-id": _ctx.expandedAlertId,
                  "editing-alert-id": _ctx.editingAlertId,
                  "is-saving": _ctx.isSaving,
                  "is-reprocessing": _ctx.isReprocessing,
                  onToggleExpand: _ctx.toggleExpand,
                  onStartEdit: _ctx.startEditing,
                  onCancelEdit: _ctx.cancelEditing,
                  onSaveEdit: _ctx.saveEditing,
                  onReprocessMessage: _ctx.handleReprocessMessage
                }, null, 8, ["alerts", "is-loading", "expanded-alert-id", "editing-alert-id", "is-saving", "is-reprocessing", "onToggleExpand", "onStartEdit", "onCancelEdit", "onSaveEdit", "onReprocessMessage"])),
            _createVNode(_component_OrphanedMessages, {
              messages: _ctx.orphanedMessages,
              "is-reprocessing": _ctx.isReprocessing,
              onReprocess: _ctx.handleReprocessMessage,
              onOpenLinkModal: _ctx.openLinkModal
            }, null, 8, ["messages", "is-reprocessing", "onReprocess", "onOpenLinkModal"])
          ])),
    _createVNode(_component_ManualLinkModal, {
      show: _ctx.showLinkModal,
      "source-message": _ctx.linkTargetMessage,
      "target-alerts": _ctx.groupedAlerts,
      "is-linking": _ctx.isLinking,
      "selected-month": _ctx.selectedMonth,
      "onUpdate:selectedMonth": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMonth) = $event)),
      "selected-year": _ctx.selectedYear,
      "onUpdate:selectedYear": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedYear) = $event)),
      months: _ctx.months,
      years: _ctx.years,
      onClose: _ctx.closeLinkModal,
      onConfirmLink: _ctx.handleLinkMessage
    }, null, 8, ["show", "source-message", "target-alerts", "is-linking", "selected-month", "selected-year", "months", "years", "onClose", "onConfirmLink"])
  ]))
}